import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useLocation } from 'react-router-dom';
import { DialogRoutePath } from './config';
import Craft from '../../views/dialog/craft';
var dialogRoutes = [
    {
        component: _jsx(Craft, {}),
        path: DialogRoutePath.CRAFT,
    },
];
export default function DialogRoutes() {
    var location = useLocation();
    return (_jsx(_Fragment, { children: dialogRoutes.map(function (dialogRoute) { return (_jsx(_Fragment, { children: location.hash.includes(dialogRoute.path.split('/')[0]) && dialogRoute.component })); }) }));
}
